import axios from "axios";
import * as ApiSettingService from "../../db/serviceApiSetting";
import Account from "../../app/models/Account";
import { env } from "../../config/env";

async function authHeaders() {
  const access = await ApiSettingService.getAccess();
  if (!access?.accessToken) throw new Error("Unable to authenticate account request");
  return { "Content-Type": "application/json", Authorization: `Bearer ${access.accessToken}` };
}

export async function updateMarketplaceAccount(accountId: string, data: Partial<Account>) {
  const response = await axios.patch(`${env.SERVER_URL}/v2/accounts/${accountId}`, data, { headers: await authHeaders() });
  return response.data;
}

export async function disconnectMarketplaceChannel(accountId: string, channel: "erp" | "chat") {
  const response = await axios.post(`${env.SERVER_URL}/v2/accounts/${accountId}/disconnect`, { channel }, { headers: await authHeaders() });
  return response.data;
}
